export const openMap = () => window.open('https://maps.app.goo.gl/apG4SUQ1Mne14C9C9', '_blank')

export const openPhone = () => window.open('tel:+5511945571917')

export const openMail = () => window.open('mailto:contato@fisioinmove.com')

export const sendMessageToWhats = (message: string) => window.open(`https://wa.me/5511945571917?text=${message}`)